import { makeStyles } from '@material-ui/core/styles';
import bg from '../assets/login-bg.jpg'

export const useStyles = makeStyles((theme) => ({
    image: {
        backgroundImage: `url(${bg})`, // Jo Hilton
        backgroundRepeat: 'no-repeat',
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    appbar: {
        backgroundColor: theme.palette.type === 'light' ? 'white' : theme.palette.grey[900],
    }
}));
